export default function getUserAttributes(state) {
  return state.loginForm?.userInfo?.UserAttributes ?? null;
}